"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var collate = exports.collate = function collate(obj, valueFunc, nextFunc, conditional) {
    var results = [];
    while (conditional(obj)) {
        results.push(valueFunc(obj));
        obj = nextFunc(obj);
    }
    return results;
};